<div class="flex flex-col flex-nowrap">
  @if (requireOverrideConfirmation && !overrideConfirmed) {
    <div
      class="mb-4"
      >
      <mat-hint>
        {{ overrideHintText }}&nbsp;
        <a href="#" (click)="$event.preventDefault(); _confirmOverride()">Continue.</a>
      </mat-hint>
    </div>
  }

  <h2 class="!text-base !font-normal !mb-0">Profile</h2>
  <app-shaker-control-profile-selection
    [selectedProfile]="selectedProfileId"
    (selectedProfileChange)="_setSelectedProfile($event)"
    [disabled]="(requireOverrideConfirmation && !overrideConfirmed) || readonly" />


  <div class="relative min-h-[300px]" #plotWrapper>
    <plotly-plot
      [config]="{ displaylogo: false }"
      [useResizeHandler]="false"
      appSafeResizeHandler
      [style]="{position: 'relative', width: '100%', height: '100%'}"
      [layout]="plotLayout"
      [data]="plotData"
      (initialized)="_runOnce()" />

  </div>

  <div class="flex justify-end">
    @if (readonly === false) {
      <button
        mat-flat-button
        color="primary"
        (click)="_editShakerProfile()"
        [disabled]="requireOverrideConfirmation && !overrideConfirmed"
        >
        Edit shaking profile
      </button>
    } @else {
      <button
        mat-stroked-button
        (click)="_showReadonlyProfileDetails()"
        >
        Show profile details
      </button>
    }
  </div>
</div>
